export const N8N_CONFIG = {
  BASE_URL: '/api/n8n-proxy',
  ENDPOINTS: {
    REGISTER: '/register',
    REGISTER_SEND_CODE: '/register/send-code',
    REGISTER_VERIFY_CODE: '/register/verify-code',
    LOGIN: '/login',
    VERIFY_TOKEN: '/verify-token',
    DEDUCT_CREDITS: '/deduct-credits',
    ADD_CREDITS: '/add-credits',
    APPLY_PROMO: '/apply-promo',
    CREATE_PURCHASE: '/create-purchase',
    USER_HISTORY: '/user/history',
    SAVE_GENERATION: '/user/save-generation',
    GET_GENERATION: '/user/get-generation',
    USER_HISTORY_IMAGES: '/user/history/images',
    IMAGE_RESOLVE: '/image/resolve',
    IMAGE_POLL: '/image/poll',
    IMAGE_POLL_KIE: '/image/poll-kie',
    PASSWORD_RESET_SEND_CODE: '/password-reset/send-code',
    PASSWORD_RESET_VERIFY_CODE: '/password-reset/verify-code'
  }
};

// HTTP-статусы, означающие, что апстрим временно недоступен (перезапуск/перегрузка).
// На таких ошибках безопасно повторить запрос — апстрим запрос не обработал.
const TRANSIENT_STATUSES = new Set([502, 503, 504]);
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Выполнить fetch с повтором при временной недоступности шлюза (502/503/504)
// или сетевой ошибке. Повтор только для безопасных случаев — gateway-ошибка
// значит, что запрос не дошёл до рабочего апстрима.
export const fetchWithRetry = async (url, options, { retries = 2, backoffMs = 600 } = {}) => {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, options);
      if (TRANSIENT_STATUSES.has(response.status) && attempt < retries) {
        await sleep(backoffMs * (attempt + 1));
        continue;
      }
      return response;
    } catch (err) {
      // Сетевая ошибка (fetch failed) — апстрип недоступен, повторяем
      lastErr = err;
      if (attempt < retries) {
        await sleep(backoffMs * (attempt + 1));
        continue;
      }
      throw err;
    }
  }
  throw lastErr;
};

// Подписанный токен сессии. Сервер берёт user_id только из него, user_id в теле игнорируется.
export const getAuthToken = () => (typeof window !== 'undefined' && localStorage.getItem('authToken')) || undefined;

// Клиентская обертка
export const n8nRequest = async (endpoint, data, extraHeaders = undefined) => {
  try {
    const response = await fetchWithRetry('/api/n8n-proxy', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ endpoint, data: { token: getAuthToken(), ...data }, headers: extraHeaders })
    });
    const json = await response.json();
    // 401 вне логина = токен истёк, подделан или старого (неподписанного) формата: закрываем сессию.
    // Иначе баланс замерзает, а списания молча падают.
    if (response.status === 401 && endpoint !== N8N_CONFIG.ENDPOINTS.LOGIN && getAuthToken()) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      window.location.href = '/';
    }
    if (!response.ok) {
      // Достаём реальную ошибку из details (n8n может вернуть объект или массив)
      const details = Array.isArray(json?.details) ? json.details[0] : json?.details;
      const errorMsg = details?.error || json?.error || `HTTP error ${response.status}`;
      const err = new Error(errorMsg);
      err.status = response.status;
      throw err;
    }
    return json;
  } catch (error) {
    console.error('n8n proxy request error:', error);
    throw error;
  }
};
